import React from "react";

export const InitialNoge = () => {
  return (
    <svg
      width="78"
      height="55"
      viewBox="0 0 78 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4727 8.78516L17.4883 53.9688H13.8066V8.78516H20.4727Z"
        stroke="#264D51"
        strokeWidth="0.836735"
      />
      <path
        d="M63.1729 8.78516V53.9688H59.4912L56.5068 8.78516H63.1729Z"
        stroke="#264D51"
        strokeWidth="0.836735"
      />
      <path d="M0 0H77.8163V9.20408H0V0Z" fill="#264D51" />
    </svg>
  );
};
